import { getFAQPanel, getHelpCallPanel, getHelpMsgPanel } from '../sharedTemplates/NeedHelpTemplates';
import { useHistory } from 'react-router-dom';
const NeedHelpView = props => {
  const { contentData } = props;
  const { helpSectionHeadline } = contentData;
  const history = useHistory();

  return (
    <div className='get-help-offers-container'>
      <div className='get-help-section'>
        <h2 className='help-text'>{helpSectionHeadline}</h2>
        <div className='help-block-container'>
          {getHelpCallPanel(props)}
          {getHelpMsgPanel(props)}
        </div>
        {getFAQPanel(props, history)}
      </div>
    </div>
  );
};

export default NeedHelpView;
